import "@cloudscape-design/global-styles/index.css";
import './App.css';
import React, { useEffect } from 'react';
import { useNavigate, BrowserRouter , Route, Routes, Navigate, Link as RouterLink, useParams } from 'react-router-dom';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Grid from '@cloudscape-design/components/grid';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import HelpPanel from '@cloudscape-design/components/help-panel';
import TestForm from './pages/indicator-submission';

import Navigation from './components/navigation';
import Breadcrumbs, {BreadcrumbProvider} from './components/breadcrumbs';

import Shell from './layouts/shell';

import { FormFull } from 'pages/indicator-submission/components/form'
import { TableSelectFilter } from 'pages/my-applications/index';
import ApplicationDetails from 'pages/application/index';
import ApplicationSummary from 'pages/application/application-summary';
import { useAuth } from './AuthContext';
import { AuthProvider } from './AuthContext';
import SignInForm from './Signin'
import { Amplify } from 'aws-amplify';
import AppHelpPanel from './components/help-panel';
import { variationData, breakdownItems, productionMetrics, quote, notes } from './data';
import { some } from 'lodash';

import { applyTheme } from "@cloudscape-design/components/theming";
import { brandTheme as theme } from "./theme";

const { reset } = applyTheme({ theme });


Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
      region: process.env.REACT_APP_APPSYNC_REGION,
    }
  }
});


const IndicatorSubmissionPage = () => {
  const { indicatorSubmissionID } = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" info={<Link variant="info">Indicator Submission</Link>}>
        Indicator Submission
      </Header>
    }
  >
    <FormFull indicatorSubmissionID={indicatorSubmissionID} />
  </ContentLayout>
);
}
const MyApplicationsPage = () => (
  <ContentLayout
  >
    <TableSelectFilter />
  </ContentLayout>
);


const ApplicationDetailsPage = () => {
  const{ applicationID }  = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" info={<Link variant="info">Application Summary Page</Link>}>
        Application Summary Page
      </Header>
    }
  >
    <ApplicationDetails applicationID={applicationID}/>
  </ContentLayout>
  )
};

const ApplicationSummaryPage = () => {
  const{ applicationID }  = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" >
        Application Summary Page
      </Header>
    }
  >
    <ApplicationSummary applicationID={applicationID}/>
    {/* <ApplicationDetailsTable loadHelpPanelContent={null} applicationID={applicationID}/> */}
  </ContentLayout>
  )
};


const NavLinks = () => (
  <div className="nav-links">
    <RouterLink to="/indicator-submission" className="nav-link">Indicator Submission</RouterLink>
    <RouterLink to="/my-applications" className="nav-link">Applications</RouterLink>
    <RouterLink to="/application-details" className="nav-link">Application Details</RouterLink>

   
  </div>
);
export const ProtectedRoute = ({ children, requiredRole }) => {
  const { auth } = useAuth();

  if (!auth) {
    return <Navigate to="/authentiate" replace />;
  }
  
  if (requiredRole && auth.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

const SignOutComponent = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/', { replace: true });
  }, []);

  return null;
};

function App() {
  return (
    <BreadcrumbProvider>
    <AuthProvider>
    <BrowserRouter>
    <div className="App">
    <Shell
        defaultPadding
        disableOverlap
        headerVariant="high-contrast"
        breadcrumbs={<Breadcrumbs />}
        navigation={<Navigation />}
        tools={<AppHelpPanel/>}
      >
          <Routes>
            <Route path="/authentiate" element={<SignInForm />} />
            <Route path="/indicator-submission/:indicatorSubmissionID" 
            element={
            <ProtectedRoute >
              <IndicatorSubmissionPage />
              </ProtectedRoute>
            } />

            <Route path="/my-applications" 
            element={
              <ProtectedRoute >
            <MyApplicationsPage />
            </ProtectedRoute>
            }
            />
            <Route path="/application-details/:applicationID" 
            element={
              <ProtectedRoute >
            <ApplicationDetailsPage />
            </ProtectedRoute>
            } />


            <Route path="/application-summary/:applicationID" 
            element={
              <ProtectedRoute >
            <ApplicationSummaryPage />
            </ProtectedRoute>
            } />

            <Route path="/" 
            element={
            <Navigate to="/my-applications" replace />
            } />
            <Route 
                path="/signout" 
                element={
                  <SignOutComponent />
                }
              />      
          </Routes>

    </Shell>

    </div>
    </BrowserRouter>
    </AuthProvider>
    </BreadcrumbProvider>

  );
}


export default App;
